module.exports = __webpack_public_path__ + "img/img85.9ac9b68a.svg";